import moment from "moment";
import React, { useEffect, useState } from "react";
import { useWebinarPageContext } from "../..";
import { useSpeakerContext } from "../../../../contexts/SpeakerContext";
import close from "../../../../assets/images/close.png";
import styles from "./index.module.scss";

function SessionDetails({ setShowSessionDetails }) {
  const { getMultipleSpeakersData } = useSpeakerContext();
  const [speakerData, setSpeakerData] = useState([]);
  const [agendaDetails, setAgendaDetails] = useState({});
  const { state } = useWebinarPageContext();

  useEffect(() => {
    setAgendaDetails(
      state.agenda.mainData.find(
        ({ id }) => id === state.baseInfo.ongoingagendaid
      )
    );
  }, [state.baseInfo]);

  useEffect(() => {
    getMultipleSpeakersData(agendaDetails.speakers).then((s) =>
      setSpeakerData(s)
    );
  }, [agendaDetails]);

  const handleClick = () => {
    setShowSessionDetails(false);
  };
  return (
    <>
      <div
        className="modalOverlayWithTint modalOverlay"
        onClick={handleClick}
      />
      <div className={styles.sessionContainer}>
        <div onClick={handleClick} className={styles.close}>
          <img src={close} alt="Close" />
        </div>
        <div className={styles.heading}>
          <div className={styles.title}>{agendaDetails.title}</div>
          <div className={styles.subheader}>
            Ongoing Session
            <div className={styles.subdetails}>
              {agendaDetails.description}
              <div className={styles.time}>
                {moment(agendaDetails.time).format("hh:mm A")}
              </div>
            </div>
          </div>
        </div>
        {speakerData.length > 0 && (
          <div className={styles.speakerList}>
            Speakers
            {React.Children.toArray(
              speakerData.map((speaker) => (
                <div className={styles.speaker}>
                  <img src={speaker.photoUrl} alt="" />
                  <div>
                    <div className={styles.name}>{speaker.name}</div>
                    <div className={styles.details}>{speaker.designation}</div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SessionDetails;
